import React, { useRef } from "react";
import { useField } from "formik";
import { TextInput } from "@mantine/core";
import { createStyles } from "@mantine/emotion";

const useStyles = createStyles((theme) => ({
  textfield: {
    marginTop: "0",
    marginBottom: "16px",
  },
}));

const TextField = (props) => {
  const { classes } = useStyles();
  const {
    placeholder,
    min,
    type,
    max,
    required,
    disabled,
    autoFocus,
    label,
    name,
    autoComplete,
  } = props;
  const [field, meta, helpers] = useField(name);
  const { touched, error, value } = meta;
  const { setValue } = helpers;
  const ref = useRef(null);

  return (
    <TextInput
      {...field}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      className={classes.textfield}
      type={type}
      placeholder={placeholder}
      min={min}
      variant="default"
      max={max}
      required={required}
      disabled={disabled}
      autoFocus={autoFocus}
      label={label}
      ref={ref}
      error={touched && error}
      autoComplete={autoComplete}
    />
  );
};

export default TextField;
